import React from "react";

interface CardGradientProps {
  className?: string;
  width?: string | number;
  height?: string | number;
}

const CopyIcon: React.FC<CardGradientProps> = ({
  className,
  width = "18",
  height = "20",
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="6"
        y="2.00098"
        width="10"
        height="12"
        rx="3"
        stroke="#FFA686"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2 9.00098V15.001C2 16.6578 3.34315 18.001 5 18.001H11"
        stroke="#CFB2FF"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default CopyIcon;
